module.exports = __webpack_public_path__ + "img/tankNo.999ef2c9.png";